import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {ICustomerPortalService, Policy, ProductsEnum, Quote, Subscription, Types} from "@falcon/services";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {authorize, Overlay} from "@athena-portal/components";
import {YourAnnualQuotesPanel} from "./YourAnnualQuotesPanel";

interface IProps extends RouteComponentProps<{}> {
}

interface IState {
    quotes?: Quote[];
    policies?: Policy[];
    subscription? : Subscription;
}

@authorize
export class AnnualQuotesPage extends React.Component<IProps, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: Readonly<IProps>) {
        super(props);
        this.state = {}
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Your annual quote(s)");
        this.customerPortalService.getQuotes().subscribe((quotes: Quote[]) => this.setState({
            quotes: this.getQuotesByProduct(quotes, ProductsEnum.WOLF_MOTOR)}));
        this.customerPortalService.getUserPoliciesWithLatestVersions().subscribe((policies: Policy[]) => {
            this.setState({policies});

            if (policies && policies.length > 0) {
                this.customerPortalService.getSubscription().subscribe((subscription: Subscription) => {
                    this.setState({subscription});
                });
            }
        });
    }

    public render() {
        const {policies, quotes, subscription} = this.state;

        if (quotes && policies) {
            return (
                <React.Fragment>
                    <FalconHeader/>
                    <YourAnnualQuotesPanel
                        quotes={quotes}
                        isActivePoliciesPresent={policies.length > 0}
                        policies={policies}
                        subscription={subscription}/>
                    <FalconFooter/>
                </React.Fragment>
            )
        } else {
            return <Overlay show={true}/>
        }
    }

    private getQuotesByProduct(quotes: Quote[], product: string): Quote[] {
        return quotes?.filter((quote) => quote?.product === product);
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/quotesPage/AnnualQuotesPage.tsx